import React from 'react';
import AddTenantModal from '../../../../../components/AddTenantModal';
import { modalNames } from '../../../shared/configs/modal';
import {
  useModalMethods,
  useModalWatch,
} from '../../../shared/packages/modalManager';

const modalName = modalNames.addTenant;

const ModalForm = () => {
  const { isOpen, props } = useModalWatch({ name: modalName });

  const { close } = useModalMethods();

  const handleCancel = () => close(modalName);

  return <AddTenantModal visible={isOpen} onCancel={handleCancel} {...props} />;
};

export default ModalForm;
